import type WebSocket from 'ws';
import type { SessionWorktreeManager } from '../../worktrees/manager.js';
import type { CliE2eeRuntime } from '../../lib/e2ee/index.js';
import { executeCodeNavRequest } from './execute-code-nav-request.js';
import type { CodeNavRequestMessage } from './types.js';
import { sendCodeNavResponse } from './send-code-nav-response.js';

export function handleCodeNavRequest(
  msg: CodeNavRequestMessage,
  socket: WebSocket,
  e2ee?: CliE2eeRuntime,
  sessionWorktreeManager?: SessionWorktreeManager,
): void {
  void (async () => {
    const body = await executeCodeNavRequest(msg, sessionWorktreeManager);
    sendCodeNavResponse(socket, e2ee, {
      type: 'code_nav_response',
      id: msg.id,
      ...body,
    });
  })();
}
